import { Row, SortingFn } from '@tanstack/react-table';
import { IProductKeyword } from 'types';

export const caseInsensitiveStringsOrder = (rowA: Row<any>, rowB: Row<any>, columnId: string) => {
    const firstVal: string = rowA.getValue(columnId) ?? '';

    const secondVal: string = rowB.getValue(columnId) ?? '';

    return firstVal.localeCompare(secondVal, undefined, { sensitivity: 'base' });
};

export const SORTING_FNS: Record<string, SortingFn<any>> = {
    caseInsensitive: caseInsensitiveStringsOrder,
};

export const sortProductKeywords = (rowA: Row<any>, rowB: Row<any>, columnId: string) => {
    if (
        columnId === 'keywords' ||
        (columnId === 'priority_keywords' &&
            Array.isArray(rowA.getValue('keywords')) &&
            Array.isArray(rowB.getValue('keywords')))
    ) {
        if (columnId === 'keywords') {
            const firstVal: IProductKeyword[] = (rowA.getValue('keywords') as IProductKeyword[]).filter(
                (k: IProductKeyword) => !k.is_priority,
            );
            const secondVal: IProductKeyword[] = (rowB.getValue('keywords') as IProductKeyword[]).filter(
                (k: IProductKeyword) => !k.is_priority,
            );
            return firstVal.length - secondVal.length;
        }
        if (columnId === 'priority_keywords') {
            const firstVal: IProductKeyword[] = (rowA.getValue('keywords') as IProductKeyword[]).filter(
                (k: IProductKeyword) => k.is_priority === true,
            );
            const secondVal: IProductKeyword[] = (rowB.getValue('keywords') as IProductKeyword[]).filter(
                (k: IProductKeyword) => k.is_priority === true,
            );
            return firstVal.length - secondVal.length;
        }
    }

    if (typeof rowA.getValue(columnId) === 'string' && typeof rowB.getValue(columnId) === 'string')
        return caseInsensitiveStringsOrder(rowA, rowB, columnId);

    return 0;
};
